import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const PageWrapper = styled(motion.div)`
  position: relative;
  height: calc(100vh - ${setRem(130)});
  overflow: hidden;

  ${({ background }) =>
    background &&
    `
    background: linear-gradient(to bottom, ${setColor.whiteColor} 0 50%, ${setColor.primaryColor} 50% 100%);
  `}
`;

export const NavContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: ${setRem(40)};
  padding: 0 ${setRem(50)};
  position: absolute;
  left: 50%;
  width: 100%;
  bottom: ${setRem(40)};
  max-width: ${setRem(1024)};
  transform: translateX(-50%);
  z-index: 4;
`;

export const NavItem = styled(Link)`
  position: relative;
  background-color: #fff;
  border-radius: ${setRem(20)};
  box-shadow: 0 ${setRem(3)} ${setRem(6)} 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  color: ${setColor.primaryColor};

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70%;
  background-color: ${setColor.secondaryColor};
  padding: ${setRem(30)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &.ausflugstipps {
    width: 66.5px;
    height: 85.5px;
  }

  &.restauranttipps {
    width: 112.5px;
    height: 67.5px;
  }

  &.extras-und-verleih {
    width: 102.5px;
    height: 53px;
  }

  &.bedienung-und-anleitungen {
    width: 63px;
    height: 75px;
  }

  &.rundgang-hausboote {
    width: 78px;
    height: 78px;
  }

  &.werbefilm-hausboote {
    width: 84.5px;
    height: 61.5px;
  }

  &.hilfe-und-kontakt {
    width: 99.5px;
    height: 67.5px;
  }
`;

export const LabelContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 30%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  &:before {
    content: ' ';
    display: block;
    position: absolute;
    top: -20%;
    left: -25%;
    width: 150%;
    height: 150%;
    background: #fff;
    border-radius: 50%;
  }
`;

export const Label = styled.h3`
  position: relative;
  font-size: ${setRem(16)};
  margin-top: ${setRem(-10)};
  max-width: ${setRem(140)};
`;
